import BaseVueComponent from "common/BaseVueComponent"
import { Component, Prop } from "vue-property-decorator"
@Component
export default class ButtonDisplayBase extends BaseVueComponent {
    @Prop({ type: Number, default: 900 }) public buttonBreakpoint!: number
}
